import { AdminDashboardActionsComponent } from './admin-dashboard.actions.component';

export function AdminDashboardCtrl ($state, $scope, $translate, AdminDashboard, messages, notifications, workshopAPI, advertisementUrl, criticalMessages, user) {
  $scope.loaded = true;

  $scope.AdminDashboard = new AdminDashboard();

  $scope.advertisementUrl = advertisementUrl + '?decache=' + Math.random();
  $scope.today = new Date();
  $scope.user = user;
  $scope.user_id = $scope.user.id;
  $scope.full_name = $scope.user.full_name;
  $scope.notifications = notifications;
  $scope.criticalMessages = criticalMessages;

  $scope.tableSettings = {
    columns: [
      {
        field : 'notification',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        field : 'expires_on',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.EXPIRATION')
        },
        pipe: 'date'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick  : event => $scope.editNotification(event),
              onDeleteClick: event => $scope.deleteNotification(event)
            }
          },
          enabled: true,
          factory: AdminDashboardActionsComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('DASHBOARD_SPACE.ADMIN_DASHBOARD.NO_NOTIFICATIONS')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.editNotification(event.row);
  };

  $scope.createNotification = function () {
    $scope.AdminDashboard.createNotification().then(function () {
      messages.show($translate.instant('JS_SPACE.MESSAGES.NOTIFICATION_CREATED'), 'success');
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.deleteNotification = function (notification) {
    workshopAPI.delete('/system_notification', notification.id).then(function (data) {
      messages.show($translate.instant('JS_SPACE.MESSAGES.NOTIFICATION_DELETED'), 'success');
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.editNotification = function (notification) {
    $scope.AdminDashboard.editNotification(notification).then(function () {
      messages.show($translate.instant('JS_SPACE.MESSAGES.NOTIFICATION_UPDATED'), 'success');
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.getStats = function () {
    workshopAPI.get('/workshop_admin/workshop_statistics').then(function (stats) {
      $scope.stats = stats;
      $scope.statsLoaded = true;
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.getStats();
}